module.exports = __webpack_public_path__ + "img/Rappi.70dd7e2d.png";